export const iconFontAwesomeSecurityLandMineOn = (
	<i className="fa-solid fa-land-mine-on"></i>
);
